import { useCallback, useMemo } from 'react';

import './index.css';
import InputField from '../../../../../components/Form/InputField';
import { CandleSticksLatestOrder } from '../../../../Detail/Charts/types';
import InputDate from '../../../../../components/Form/InputDate';
import { Exchange } from '../../../../../types/exchange';
import Dropdown from '../../../../../components/Form/Dropdown';
import { colors } from '../../../../../colors';

interface Props {
  baseAsset: string;
  setBaseAsset: (baseAsset: string) => void;
  quoteAsset: string;
  setQuoteAsset: (quoteAsset: string) => void;
  startDate: string;
  setStartDate: (startDate: string) => void;
  endDate: string;
  setEndDate: (endDate: string) => void;
  setCandleSticksLatestOrder?: React.Dispatch<
    React.SetStateAction<CandleSticksLatestOrder | undefined>
  >;
  setShouldFetch: (value: boolean) => void;
  exchange: Exchange;
  setExchange: React.Dispatch<React.SetStateAction<Exchange>>;
}

const CandlesForm = (props: Props) => {
  const {
    baseAsset,
    setBaseAsset,
    quoteAsset,
    setQuoteAsset,
    setShouldFetch,
    startDate,
    setStartDate,
    endDate,
    setCandleSticksLatestOrder,
    setEndDate,
    exchange,
    setExchange,
  } = props;

  const handleBaseAssetChange = useCallback(
    (baseAsset: string) => {
      setShouldFetch(false);
      setBaseAsset(baseAsset);
      setCandleSticksLatestOrder?.(undefined);
    },
    [setBaseAsset, setCandleSticksLatestOrder, setShouldFetch],
  );

  const handleQuoteAssetChange = useCallback(
    (quoteAsset: string) => {
      setShouldFetch(false);
      setQuoteAsset(quoteAsset);
      setCandleSticksLatestOrder?.(undefined);
    },
    [setCandleSticksLatestOrder, setQuoteAsset, setShouldFetch],
  );

  const handleStartDateChange = useCallback(
    (startDate: string) => {
      setShouldFetch(false);
      setStartDate(startDate);
    },
    [setShouldFetch, setStartDate],
  );

  const handleEndDateChange = useCallback(
    (endDate: string) => {
      setShouldFetch(false);
      setEndDate(endDate);
    },
    [setEndDate, setShouldFetch],
  );

  const baseAssetField = useMemo(() => {
    return {
      label: 'Base Asset',
      value: baseAsset,
      handleValueChange: handleBaseAssetChange,
      shouldFit: true,
    };
  }, [baseAsset, handleBaseAssetChange]);

  const quoteAssetField = useMemo(() => {
    return {
      label: 'Quote Asset',
      value: quoteAsset,
      handleValueChange: handleQuoteAssetChange,
      shouldFit: true,
    };
  }, [handleQuoteAssetChange, quoteAsset]);

  return (
    <div>
      <p
        style={{
          fontWeight: 'bold',
          color: colors.white,
          marginLeft: 50,
          marginTop: -10,
        }}
      >
        Baic Params
      </p>
      <div className="candles-form">
        <div className="candles-form-item">
          <InputField config={baseAssetField} />
        </div>
        <div className="candles-form-item">
          <InputField config={quoteAssetField} />
        </div>

        <div className="candles-form-item-date">
          <InputDate
            label="Start Date"
            date={startDate}
            handleDateChange={handleStartDateChange}
          />
        </div>
        <div className="candles-form-item-date">
          <InputDate
            label="End Date"
            date={endDate}
            handleDateChange={handleEndDateChange}
          />
        </div>
        <span className="candles-form-item-date">
          <Dropdown
            config={{
              label: 'Exchange',
              value: exchange,
              handleValueChange: setExchange,
              options: Object.values(Exchange) || [],
            }}
          />
        </span>
      </div>
    </div>
  );
};

export default CandlesForm;
